/**
 * Set Dir3 
 * @param {Object} payload - Dir3 Object.
 */
export const set = ({ commit }, payload) => {
  if (!payload) {
    empty({ commit })
  } else {
    return new Promise((resolve, reject) => {
      commit('SET_CODE', payload.code)
      commit('SET_DESCRIPTION', payload.description)
      if (payload.address) {
        commit('address/SET_STREET', payload.address.street)
        commit('address/SET_POSTALCODE', payload.address.postalCode)
        commit('address/SET_TOWN', payload.address.town)
        commit('address/SET_CITY', payload.address.city)
        commit('address/SET_COUNTRY', 'ES')
      } else {
        commit('address/SET_STREET', '')
        commit('address/SET_POSTALCODE', '')
        commit('address/SET_TOWN', '')
        commit('address/SET_CITY', '')
        commit('address/SET_COUNTRY', 'ES')
      }
      commit('SET_NAME', payload.name)
      commit('SET_FIRSTNAME', payload.firstname)
      commit('SET_LASTNAME', payload.lastname)
      resolve()
    })
  }
}

export const empty = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_CODE', undefined)
    commit('SET_DESCRIPTION', undefined)
    commit('address/SET_STREET', undefined)
    commit('address/SET_POSTALCODE', undefined)
    commit('address/SET_TOWN', undefined)
    commit('address/SET_CITY', undefined)
    commit('address/SET_COUNTRY', 'ES')
    commit('SET_NAME', undefined)
    commit('SET_FIRSTNAME', undefined)
    commit('SET_LASTNAME', undefined)
    resolve()
  })
}
